export default __webpack_public_path__ + "static/media/home2M.eee011e0.webp";